/* tslint:disable */
/* eslint-disable */
/**
 * Contract
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EntitlementsResponse } from '../model';
// @ts-ignore
import type { ErrorResponse } from '../model';
/**
 * EntitlementControllerApi - axios parameter creator
 * @export
 */
export const EntitlementControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 화면이 스팀홈 영역에 들어올 때 무슨 버튼을 띄울지 정하는 판정을 돌려줌. **기관은 토큰에서 유도하므로 지정할 수 없음** — 병원 사용자든 와이브레인 직원이든 자기 소속 기관으로 판정함. 서버 열쇠(`access_key`·`secret_key`)로는 부를 수 없음(403) — 그 인증의 주체는 사용자가 아니라 구독자라 기관을 알 수 없기 때문임. 기관을 지정해 묻는 것은 `/app/api/v2/entitlements/organizations/{organizationId}` 임. `serviceType` 을 주면 그 종류의 항목이 계약이 없어도 반드시 한 줄 오고(`entitled=false`), 주지 않으면 살아 있는 계약이 있는 종류만 옴. `entitled`(쓸 수 있는가)와 `consented`(지금 살아 있는 그 계약에 신청 기록이 있는가)는 뜻이 다른 별개의 값임.
         * @summary 이용 자격·동의 여부 판정 — 사용자 토큰 전용
         * @param {GetEntitlementsServiceTypeEnum} [serviceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitlements: async (serviceType?: GetEntitlementsServiceTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/entitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serviceType !== undefined) {
                localVarQueryParameter['serviceType'] = serviceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntitlementControllerApi - functional programming interface
 * @export
 */
export const EntitlementControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntitlementControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 화면이 스팀홈 영역에 들어올 때 무슨 버튼을 띄울지 정하는 판정을 돌려줌. **기관은 토큰에서 유도하므로 지정할 수 없음** — 병원 사용자든 와이브레인 직원이든 자기 소속 기관으로 판정함. 서버 열쇠(`access_key`·`secret_key`)로는 부를 수 없음(403) — 그 인증의 주체는 사용자가 아니라 구독자라 기관을 알 수 없기 때문임. 기관을 지정해 묻는 것은 `/app/api/v2/entitlements/organizations/{organizationId}` 임. `serviceType` 을 주면 그 종류의 항목이 계약이 없어도 반드시 한 줄 오고(`entitled=false`), 주지 않으면 살아 있는 계약이 있는 종류만 옴. `entitled`(쓸 수 있는가)와 `consented`(지금 살아 있는 그 계약에 신청 기록이 있는가)는 뜻이 다른 별개의 값임.
         * @summary 이용 자격·동의 여부 판정 — 사용자 토큰 전용
         * @param {GetEntitlementsServiceTypeEnum} [serviceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntitlements(serviceType?: GetEntitlementsServiceTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntitlementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntitlements(serviceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitlementControllerApi.getEntitlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntitlementControllerApi - factory interface
 * @export
 */
export const EntitlementControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntitlementControllerApiFp(configuration)
    return {
        /**
         * 화면이 스팀홈 영역에 들어올 때 무슨 버튼을 띄울지 정하는 판정을 돌려줌. **기관은 토큰에서 유도하므로 지정할 수 없음** — 병원 사용자든 와이브레인 직원이든 자기 소속 기관으로 판정함. 서버 열쇠(`access_key`·`secret_key`)로는 부를 수 없음(403) — 그 인증의 주체는 사용자가 아니라 구독자라 기관을 알 수 없기 때문임. 기관을 지정해 묻는 것은 `/app/api/v2/entitlements/organizations/{organizationId}` 임. `serviceType` 을 주면 그 종류의 항목이 계약이 없어도 반드시 한 줄 오고(`entitled=false`), 주지 않으면 살아 있는 계약이 있는 종류만 옴. `entitled`(쓸 수 있는가)와 `consented`(지금 살아 있는 그 계약에 신청 기록이 있는가)는 뜻이 다른 별개의 값임.
         * @summary 이용 자격·동의 여부 판정 — 사용자 토큰 전용
         * @param {GetEntitlementsServiceTypeEnum} [serviceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntitlements(serviceType?: GetEntitlementsServiceTypeEnum, options?: any): AxiosPromise<EntitlementsResponse> {
            return localVarFp.getEntitlements(serviceType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntitlementControllerApi - object-oriented interface
 * @export
 * @class EntitlementControllerApi
 * @extends {BaseAPI}
 */
export class EntitlementControllerApi extends BaseAPI {
    /**
     * 화면이 스팀홈 영역에 들어올 때 무슨 버튼을 띄울지 정하는 판정을 돌려줌. **기관은 토큰에서 유도하므로 지정할 수 없음** — 병원 사용자든 와이브레인 직원이든 자기 소속 기관으로 판정함. 서버 열쇠(`access_key`·`secret_key`)로는 부를 수 없음(403) — 그 인증의 주체는 사용자가 아니라 구독자라 기관을 알 수 없기 때문임. 기관을 지정해 묻는 것은 `/app/api/v2/entitlements/organizations/{organizationId}` 임. `serviceType` 을 주면 그 종류의 항목이 계약이 없어도 반드시 한 줄 오고(`entitled=false`), 주지 않으면 살아 있는 계약이 있는 종류만 옴. `entitled`(쓸 수 있는가)와 `consented`(지금 살아 있는 그 계약에 신청 기록이 있는가)는 뜻이 다른 별개의 값임.
     * @summary 이용 자격·동의 여부 판정 — 사용자 토큰 전용
     * @param {GetEntitlementsServiceTypeEnum} [serviceType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementControllerApi
     */
    public getEntitlements(serviceType?: GetEntitlementsServiceTypeEnum, options?: RawAxiosRequestConfig) {
        return EntitlementControllerApiFp(this.configuration).getEntitlements(serviceType, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetEntitlementsServiceTypeEnum = {
    Stim: 'STIM',
    StimHome: 'STIM_HOME',
    Scan: 'SCAN',
    Hrv: 'HRV',
    NeuroGuide: 'NEURO_GUIDE',
    StimRental: 'STIM_RENTAL',
    StimProRental: 'STIM_PRO_RENTAL',
    ScanNeuroGuide: 'SCAN_NEURO_GUIDE',
    ScanHrv: 'SCAN_HRV',
    ScanHrvNeuroGuide: 'SCAN_HRV_NEURO_GUIDE'
} as const;
export type GetEntitlementsServiceTypeEnum = typeof GetEntitlementsServiceTypeEnum[keyof typeof GetEntitlementsServiceTypeEnum];
